module.exports = __webpack_public_path__ + "img/Weapon_273.a4b0e97a.png";